import type { ITaskTemplateInput, ITaskTemplateSectionRow } from '@/interfaces'
import TaskTemplateInput from './TaskTemplateInput'

class TaskTemplateSectionRow implements ITaskTemplateSectionRow {
  id?: string

  title: string

  description: string

  inputs: ITaskTemplateInput[]

  constructor(row?: any, isGetRequest?: boolean) {
    this.id = row?.id
    this.title = row?.title ?? ''
    this.description = row?.description ?? ''
    this.inputs = row?.inputs?.map((input: any) => new TaskTemplateInput(input, isGetRequest)) ?? []
  }
}

export default TaskTemplateSectionRow
